import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineUserAdd } from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import LoadableComponent from "../../../../features/Loading/LoadableComponent";
import { Ticket } from "../../../models/Ticket";
import getId from "../../../../utils/getId";
import { HiOutlineTicket } from "react-icons/hi";
import HtmlTooltip from "@mui/material/Tooltip";

interface IProps {
  passesList: Ticket[];
  loading: boolean;
  joinToExercise: (value: boolean, passId: string) => void;
  reservationList: boolean;
   exerciseStart:number;
}

const ExerciseInfoPassSelectorReservationList: React.FC<IProps> = ({ passesList, loading, joinToExercise, exerciseStart }) => {
  const { t } = useTranslation();
  const [showOptions, setShowOptions] = useState(false);

  const getFilteredPassesList = () => {
    const filteredPassesList = passesList.filter(
      (item) => item.validfrom <= exerciseStart && exerciseStart <= item.validto
    );
    return filteredPassesList;
  };

  const handleClickInOption = (value: boolean, id: string) => {
    joinToExercise(value, id);
    setShowOptions(false);
  };


  return (
    <LoadableComponent loading={loading}>
      {passesList.length > 1 ? (
        <>
          {showOptions ? (
            <div className="custom-select">


<HtmlTooltip
              placement="top"
              title={
                <React.Fragment>
                  <article
                    className="tooltip-description"
                    dangerouslySetInnerHTML={{ __html: "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie." }}
                    ></article>
                </React.Fragment>
              }
            >
          <button onClick={() => setShowOptions(false)} className="button medium padding-small button-outline-main">
                Lista rezerwowa
                <IoIosArrowDown className="icon" />
              </button>
            </HtmlTooltip>
             
            <ul className="options-list shadow">
                {getFilteredPassesList().map((option) => (
                  <React.Fragment>
                    {option.ticket === false && (
                      <li
                        className="flex-between-center"
                        key={getId(option)}
                        onClick={() => handleClickInOption(false, getId(option))}
                      >
                        <div className="flex-start-center">
                          <HiOutlineTicket className="icon" /> {option.name}
                        </div>

                        {option.entrances - option.exercises.length <= 0 && (
                          <div className="alert-red alert alert-small">Wyczerpano</div>
                        )}
                      </li>
                    )}
                  </React.Fragment>
                ))}
              </ul>
            </div>
          ) : (
            <HtmlTooltip
              placement="top"
              title={
                <React.Fragment>
                  <article
                    className="tooltip-description"
                    dangerouslySetInnerHTML={{ __html: "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie." }}
                    ></article>
                </React.Fragment>
              }
            >
              <button onClick={() => setShowOptions(true)} className="button medium padding-small button-outline-main">
                Lista rezerwowa
                <IoIosArrowUp className="icon" />
              </button>
            </HtmlTooltip>

          )}
        </>
      ) : (
        <HtmlTooltip
        placement="top"
        title={
          <React.Fragment>
            <article
              className="tooltip-description"
              dangerouslySetInnerHTML={{ __html: "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie." }}
            ></article>
          </React.Fragment>
        }
      >
         <button
          onClick={() => joinToExercise(false, "null")}
          className="button medium padding-small button-outline-main"
        >
          Lista rezerwowa
          <AiOutlineUserAdd className="icon" />
        </button>
      </HtmlTooltip>
 
      )}
    </LoadableComponent>
  );
};

export default ExerciseInfoPassSelectorReservationList;
